import {RemotePostCreateRequestPreview} from 'data/usecases/private/refund/request-preview';
import {PostCreateRequestPreview} from 'domain/usecases/private/refund/request-preview';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePostCreateRequestPreview = (): PostCreateRequestPreview =>
	new RemotePostCreateRequestPreview(
		makeBFFApiUrl(RefundFlowEndPoints.requestPreview),
		makeAuthorizeHttpClientDecorator(),
	);
